<template>
  <DropdownMenuRoot
    :open="open"
    :default-open="defaultOpen"
    :modal="modal"
    @update:open="$emit('update:open', $event)"
  >
    <slot name="trigger" />

    <DropdownMenuPortal :to="portalTarget">
      <slot name="menu" />
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>

<script lang="ts" setup>
import { DropdownMenuRoot, DropdownMenuPortal } from 'reka-ui'

withDefaults(
  defineProps<{
    defaultOpen?: boolean
    modal?: boolean
    open?: boolean
    portalTarget?: string | HTMLElement
  }>(),
  {
    defaultOpen: false,
    modal: true,
    open: undefined,
    portalTarget: undefined,
  }
)

defineEmits<{
  'update:open': [open: boolean]
}>()
</script>
